module.exports = __webpack_public_path__ + "img/devis.5e0b394a.png";